<div class="login-section">
  <div class="login-container">
    <div class="login-upper-section">
      <span class="login-title-text">Login to dp</span>
      <div class="container">
        <span class="login-content-text-statement"
          >Accounts link to your FC - {{ familyCode }}</span
        >
        @for(item of details;track item){
        <div class="login-content-inside-box-boder">
          <div class="login-content-inside-box">
            <div class="login-content-inside-box-text">
              <span class="login-content-text">Role</span>
              <span class="login-content-text-bold">{{ item.role_name }}</span>
            </div>
            <div class="login-content-inside-box-text">
              <span class="login-content-text">Email</span>
              <span class="login-content-text-bold">{{ item.email_id }}</span>
            </div>
          </div>
        </div>
        }
      </div>
      <div class="container">
        <span class="login-content-text"
          >We’ll send an OTP to verify this email
        </span>
        <div class="input-field-container">
          <span class="input-level-text">Primary account</span>
          <input
            type="text"
            class="input-field dp-input-control"
            placeholder="Enter your email address"
            [formControl]="email"
            [matAutocomplete]="autofc"
          />
          <mat-autocomplete autoActiveFirstOption #autofc="matAutocomplete">
            @for(item of details;track item) {
            <mat-option
              [value]="item.email_id"
              (onSelectionChange)="getMemKey(item.email_id)"
            >
              {{ item.email_id }}
            </mat-option>
            }
          </mat-autocomplete>
        </div>
      </div>
      <div class="container">
        <button class="login-button dp-primary-btn" (click)="APIcall()">
          Verify code
        </button>
        <!-- <a [routerLink]="'/reset-password'" class="forgot-password-text"
          >Forgot password?</a
        > -->
      </div>
    </div>

    >
    <div class="footer-section">
      <div class="registration-ask-text">Not registered with DP Works?</div>
      <a class="registration-now-text">Register now</a>
    </div>
  </div>
</div>
